import React from 'react';

import { ErrorContent, ErrorTextContainer } from './SignUpFormModal.styled';
import { Loader } from 'components/Loader/Loader';
import { Button } from 'components/v2/Buttons/Button/Button';
import { Modal } from 'components/v2/Modal/Modal';
import { utils } from 'kb-shared';

import { SignUpFormModalProps } from './SignUpFormModal.types';

const { KBContacts } = utils;

export const SignUpFormModal = (props: SignUpFormModalProps) => {
  const {
    referralSourcesLoadStatus,
    timeZonesLoadStatus,
    locationsLoadStatus,
    patientInterestLoadStatus
  } = props;
  const loadStatuses = [
    referralSourcesLoadStatus,
    timeZonesLoadStatus,
    locationsLoadStatus,
    patientInterestLoadStatus
  ];
  const modalVisible = loadStatuses.some(s => !s);
  const loaderVisible = loadStatuses.some(s => s == null);

  if (!modalVisible) return null;

  return (
    <Modal title="Loading Sign Up Form" open={true} onCancel={() => {}} closable={false}>
      {loaderVisible ? (
        <Loader />
      ) : (
        <ErrorContent>
          <ErrorTextContainer>
            <span>
              We are sorry, we were unable to load this form.
              <br />
              Please reload the page, or contact us at{' '}
              <a className="link" href={`mailto:${KBContacts.navigatorEmail}`}>
                {KBContacts.navigatorEmail}
              </a>
              .
            </span>
          </ErrorTextContainer>
          <Button label="Reload" onClick={() => window.location.reload()} />
        </ErrorContent>
      )}
    </Modal>
  );
};
